import React from 'react';
import useUsers from "../../store/users/usersContext";
import useTreatments from '../../store/treatments/treatmentsContext';
import { COLORS } from '../../config';
import SecondaryButtonAccent from '../../components/Buttons/SecondaryButtonAccent';
import PlusIcon from '../../components/Icons/solid/PlusIcon';
import AddCollaboratorModal from './AddCollaboratorModal';
import RemoveCollaboratorModal from './RemoveCollaboratorModal';
import CollaboratorCard from '../../components/Cards/CollaboratorCard';
import MoonLoader from 'react-spinners/MoonLoader';

function Collaborators({treatmentInfo, userAccount}) {

    const {
        usersState : { allClinicPartners }, 
        getClinicPartners
    } = useUsers();

    const {
        treatmentsState: { treatmentCollaborators },
        addTreatmentCollaborator,
        getTreatmentCollaborators,
        removeTreatmentCollaborator
    } = useTreatments();

    const treatmentId = treatmentInfo._id;
    const [isLoading, setIsLoading] = React.useState(true);
    
    const clinicId  = treatmentInfo.center_of_excellence._id;

    React.useEffect(() => {
        if (userAccount.isAdmin) getClinicPartners(clinicId)
      
    }, [userAccount])

    React.useEffect(() => {
        if(treatmentId){
            getTreatmentCollaborators(treatmentId).then(() => setIsLoading(false));
        }
      
    }, [treatmentId]);

    const [showRemoveCollaborator, setShowRemoveCollaborator] = React.useState(false);  
    const [showAddCollaborator, setShowAddCollaborator] = React.useState(false)
    const [selectedCollaborator, setSelectedCollaborator] = React.useState({id: '', email: ''});

    const onDelete = (collaborator) => {
        setShowRemoveCollaborator(true); 
        setSelectedCollaborator({ id: collaborator.user_id._id, email: collaborator.user_id.email })
    }
    

  return (
    <div className="bg-white rounded shadow pt-10 pb-4 h-80 flex-grow flex flex-col">
        {userAccount.isAdmin && <>
            <AddCollaboratorModal 
                addTreatmentCollaborator={addTreatmentCollaborator} 
                setShowAddCollaborator={setShowAddCollaborator} 
                showAddCollaborator={showAddCollaborator} 
                treatmentId={treatmentId} 
                allClinicPartners={allClinicPartners} 
                treatmentCollaborators={treatmentCollaborators}
            />
            <RemoveCollaboratorModal 
                removeTreatmentCollaborator={removeTreatmentCollaborator} 
                showRemoveCollaborator={showRemoveCollaborator} 
                setShowRemoveCollaborator={setShowRemoveCollaborator} 
                selectedCollaborator={selectedCollaborator} 
                treatmentId={treatmentId} 
            />
        </>}
        <div className='flex justify-between px-10'>
            <h1 className="text-2xl text-secondary">Medical team</h1>
            {userAccount.isAdmin && <SecondaryButtonAccent onClick={() => setShowAddCollaborator(true)} text="Add collaborator" icon={<PlusIcon fill={COLORS.colorPrimary}/>}/>}
        </div>
        {isLoading ?
        <div className='flex justify-around min-h-170 pt-8'>
            <MoonLoader color={COLORS.colorPrimary}/>
        </div> :
        <div className='h-full overflow-x-hidden overflow-y-auto mt-4 mr-4'>
        {treatmentCollaborators.length ?
            treatmentCollaborators.map((collaborator, index) => {
            return (
            <div key={collaborator._id}  className={`${index !== 0 && 'mt-4'} px-10 -mr-4`}>
                <CollaboratorCard userAccount={userAccount} collaborator={collaborator} onDelete={onDelete}/>
            </div>
            )
            })
            :
            <p className="mb-5 flex text-secondary items-center px-10 mt-6">No collaborators are assigned to this treatment.</p>
        }   
        </div>
        }
        
    </div>
  )
}

export default Collaborators;

